import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { getAllDeepLinks, getPageInterface } from 'app/app-page-helpers';
import { hasClientSmallScreen } from 'environments/environment-helpers';
import { IHelpCardPage } from 'pages/help-card-page/help-card-page-interface';
import { HelpCardPopover } from 'components/help-card-popover/help-card-popover';
import { BackdropMode } from 'components/popover-host/popover-host';
import { NavController } from 'providers/nav-controller';
import { PopoverController } from 'providers/popover-controller';
import { SettingsService } from 'services/settings.service';

@Component({
    selector: 'help-link',
    templateUrl: 'help-link.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpLinkComponent {
  @Input() helpId: string = ''; // we deliberately don't put just "id" here, so it is easier to find all references in html sources
  @Input() redirectId: string = ''; // if set, this will be used to redirect to the page and element of id
  @Input() variant: 'default' | 'gray' = 'default'; // 'gray' for secondary text color instead of blue
  visited = false;

  constructor(
    private navCtrl: NavController,
    private settings: SettingsService,
    private popoverCtrl: PopoverController,
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {
    let mySettings = JSON.parse(this.settings.helpSeenJSON || ' {}') || {};
    this.visited = mySettings[this.helpId];
  }

  onClick(ev: Event) {
    ev.stopPropagation();
    ev.preventDefault();
    if (this.helpId) {
      // if inside a popover, show as overlay; otherwise navigate normally
      // on small screens, always use full page for better readability
      const inPopover = this.elementRef.nativeElement.closest('.popover');
      if (inPopover && !hasClientSmallScreen()) {
        void this.popoverCtrl.present(HelpCardPopover, { helpId: this.helpId }, {
          targetFromElement: this.elementRef.nativeElement,
          overlayPreviousPopover: true,
          animate: true,
          backdropMode: BackdropMode.Visible,
        });
      } else {
        // if on small screen and inside a popover, dismiss it first
        if (inPopover) {
          const popover = this.popoverCtrl.popoverHost?.popovers.find(p =>
            p.componentRef.location.nativeElement === inPopover);
          if (popover) {
            void this.popoverCtrl.dismiss(popover.componentRef.instance);
          }
        }
        void this.navCtrl.pushAsync(IHelpCardPage, {
          helpId: this.helpId,
        });
      }
    } else if (this.redirectId) {
      // match string of the form @redirect:pageSegmentId.elementId, both pageSegmentId and elementId needs to be present
      const matchResult = this.redirectId.match(/^@redirect:([^.]+)\.([^.]+)$/);
      if (matchResult) {
        const pageSegmentId = matchResult[1];
        const pageName = getAllDeepLinks().find(link => link.segment.startsWith(pageSegmentId))?.name;
        const elementId = matchResult[2];
        void this.navCtrl.pushAsync(getPageInterface(pageName), {
          autoFocusElementId: elementId,
        });
      }
    }

  }
}
